module.exports = __webpack_public_path__ + "static/media/side-bar-teams-icon-active.e8e89ebf.svg";